export default __webpack_public_path__ + "static/productbg-cef1ee9fa60c97d8b4469d49a445782b.png";